import { Inject, Injectable } from "@angular/core";
import {
  addDoc,
  collection,
  doc,
  Firestore,
  getDocs,
  limit,
  orderBy,
  query,
  startAfter,
  startAt,
  updateDoc,
  where,
} from "@angular/fire/firestore";
import { Observable, of } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class UserService {
  private PAGE_SIZE = 5; // Quantidade de itens por página
  private firstDoc: any = null;
  private lastDoc: any = null;
  public pageStack: any[] = []; // Pilha de páginas para navegação
  public hasMoreItems: boolean = true;
  private collectionName = "users";
  constructor(private firestore: Firestore) {}

  async postAdd(company: any) {
    const collectionRef = collection(this.firestore, this.collectionName);
    const docRef = await addDoc(collectionRef, company);
    return await updateDoc(docRef, { id: docRef.id });
  }

  async postSave(id: string, company: any) {
    const docRef = doc(this.firestore, this.collectionName, id);
    return await updateDoc(docRef, company);
  }

  async postUpdateFoto(id: string, url: any) {
    const docRef = doc(this.firestore, this.collectionName, id);
    return await updateDoc(docRef, {
      foto: url,
    })
      .then(() => console.log("Documento atualizado com sucesso!"))
      .catch((error) => console.error("Erro ao atualizar documento:", error));
  }

  async getByEmail(email: string) {
    const collectionRef = collection(this.firestore, this.collectionName);
    const q = query(collectionRef, where("email", "==", email));
    const snapshot = await getDocs(q);
    if (!snapshot.empty) {
      const userData = snapshot.docs[0].data();
      return userData;
    } else {
      return null;
    }
  }

  async getByUid(uid: string) {
    const collectionRef = collection(this.firestore, this.collectionName);
    const q = query(collectionRef, where("uid", "==", uid));
    const snapshot = await getDocs(q);
    if (!snapshot.empty) {
      const userData = snapshot.docs[0].data();
      return userData;
    } else {
      return null;
    }
  }

  getItems(next: boolean = true): Observable<any[]> {
    if (next && !this.hasMoreItems) {
      return of([]);
    }

    let collectionRef = collection(this.firestore, "users");
    let q = query(
      collectionRef,
      orderBy("nomeCompleto", "asc"),
      limit(this.PAGE_SIZE)
    );

    if (next && this.lastDoc) {
      q = query(
        collectionRef,
        orderBy("nomeCompleto", "asc"),
        startAfter(this.lastDoc),
        limit(this.PAGE_SIZE)
      );
    } else if (!next && this.pageStack.length > 1) {
      this.pageStack.pop();
      const previousDoc = this.pageStack[this.pageStack.length - 1];
      q = query(
        collectionRef,
        orderBy("nomeCompleto", "asc"),
        startAt(previousDoc),
        limit(this.PAGE_SIZE)
      );
    }

    return new Observable((observer) => {
      getDocs(q)
        .then((snapshot) => {
          if (snapshot.empty) {
            this.hasMoreItems = false;
            observer.next([]);
            observer.complete();
            return;
          }

          this.firstDoc = snapshot.docs[0];
          this.lastDoc = snapshot.docs[snapshot.docs.length - 1];

          if (next) {
            this.pageStack.push(this.firstDoc);
          }

          this.hasMoreItems = snapshot.docs.length === this.PAGE_SIZE;

          observer.next(
            snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }))
          );
          observer.complete();
        })
        .catch((error) => {
          observer.error(error);
        });
    });
  }
}
